import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { EmployeeCashbookDto } from "./employee-cashbook-dto";

export class CashbookResponseModel extends GlobalResponseObject{
    data?: EmployeeCashbookDto;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: EmployeeCashbookDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}
